<template>
	<tr>
		<td class="text-center">
			{{ item.num }}
		</td>
		<td class="text-center"
			:style="editMode ? 'min-width: 250px;' : 'min-width: 200px;'"
		>
			<template v-if="editMode && !item.delivery">
				<a-text-field-inline
					v-model="item.name"
					required
					single-line
					:disabled="item.mmId > 0"
				>
					<template v-slot:label v-if="!item.name && showErrors">
						<span class="error--text caption text-no-wrap">Обязательное поле</span>
					</template>
				</a-text-field-inline>
			</template>
			<template v-else>
				{{ item.name }}
			</template>
		</td>
		<td v-if="type != 4"
			class="text-center"
			:style="editMode ? 'min-width: 250px;' : 'min-width: 200px;'"
		>
			<template v-if="editMode && !item.delivery">
				<a-text-field-inline
					v-model="item.chars"
					:disabled="item.mmId > 0"
				></a-text-field-inline>
			</template>
			<template v-else>
				<template v-if="linkifiedChars.length > limitChars && !expandChars">
					<span v-text="shortenedChars" @click="expandChars = true" style="cursor: pointer;"></span>
				</template>
				<template v-else>
					<span v-html="linkifiedChars"></span>
				</template>
			</template>
		</td>
		<td v-if="type != 4"
			class="text-no-wrap text-center"
			:style="editMode ? 'width: 70px;' : ''"
		>
			<template v-if="editMode && !item.delivery">
				<a-text-field-inline
					v-model="item.unit"
					required
					single-line
					:disabled="item.mmId > 0"
				>
					<template v-slot:label v-if="!item.unit && showErrors">
						<span class="error--text caption text-no-wrap">Обязательное поле</span>
					</template>
				</a-text-field-inline>
			</template>
			<template v-else>
				{{ item.unit }}
			</template>
		</td>
		<td v-if="type != 4"
			class="text-no-wrap text-center"
			:style="editMode ? 'width: 70px;' : ''"
		>
			<template v-if="editMode && !item.delivery">
				<a-number-field-inline
					v-model="qtty"
					@change="qttyChange"
					digits="0"
					:rules="[ v => (v != '0') || 'Обязательное поле' ]"
					:validate-on-blur="true"
				>
					<template v-slot:prepend-inner v-if="(qtty == 0) && showErrors">
						<span class="error--text caption text-no-wrap">Обязательное поле</span>
					</template>
				</a-number-field-inline>
			</template>
			<template v-else-if="!item.delivery">
				{{ item.qty }}
			</template>
		</td>
		<template v-for="i in 3">
			<template v-if="visible[i - 1]">
				<pr-line-quotation
					v-if="type != 4"
					:key="'quot' + i"
					:ref="'q' + i"
					:sum-net.sync="item.qns[i - 1].sumNet"
					:qty.sync="item.qty"
					:edit-mode="editMode || editQnsMode"
					:grey="qSelected > 0 && qSelected != i"
					:delivery="item.delivery"
					:num="item.num"
					@focusPrice="$emit('focus', item, i, 'price')"
					@blurPrice="$emit('blur')"
					@focusSum="$emit('focus', item, i, 'sum')"
					@blurSum="$emit('blur')"
				></pr-line-quotation>
				<pr-line-bonus
					v-else
					:key="'bonus' + i"
					:ref="'q' + i"
					:sum-net.sync="item.qns[i - 1].sumNet"
					:edit-mode="editMode || editQnsMode"
				></pr-line-bonus>
			</template>
		</template>
		<td v-if="editMode" class="text-no-wrap text-center">
			<v-tooltip
				bottom
				open-delay="300"
				v-if="!item.delivery"
			>
				<template v-slot:activator="{ on }">
					<v-icon
						small
						v-on="on"
						class="mx-1"
						@click="copy"
					>
						file_copy
					</v-icon>
				</template>
				<span>Копировать строку</span>
			</v-tooltip>
			<v-tooltip
				bottom
				open-delay="300"
			>
				<template v-slot:activator="{ on }">
					<v-icon
						small
						v-on="on"
						class="mx-1"
						@click="remove"
					>
						delete
					</v-icon>
				</template>
				<span>Удалить строку</span>
			</v-tooltip>
			<!-- <template v-if="item.num != length"> -->
				<v-tooltip
					bottom
					open-delay="300"
				>
					<template v-slot:activator="{ on }">
						<v-icon
							small
							v-on="on"
							class="mx-1"
							@click="down"
							:disabled="item.num == length"
						>
							keyboard_arrow_down
						</v-icon>
					</template>
					<span>Вниз</span>
				</v-tooltip>
			<!-- </template>
			<template v-if="item.num != 1"> -->
				<v-tooltip
					bottom
					open-delay="300"
				>
					<template v-slot:activator="{ on }">
						<v-icon
							small
							v-on="on"
							class="mx-1"
							@click="up"
							:disabled="item.num == 1"
						>
							keyboard_arrow_up
						</v-icon>
					</template>
					<span>Вверх</span>
				</v-tooltip>
			<!-- </template> -->
		</td>
	</tr>
</template>

<script>
	import { toStr, toNum, linkify } from '../../../js/common'
	import aNumberFieldInline from '../../base/ANumberFieldInline.vue'
	import aTextFieldInline from '../../base/ATextFieldInline.vue'
	import prLineQuotation from './PrLineQuotation.vue'
	import prLineBonus from './PrLineBonus.vue'

	export default {
		components: {
			aNumberFieldInline,
			aTextFieldInline,
			prLineQuotation,
			prLineBonus,
		},
		props: {
			item: {
				type: Object,
				default: function () {
					return {
						num: 0,
						name: '',
						delivery: 0,
						chars: '',
						unit: '',
						qty: '',
						qns: [
							{
								sumNet: ''
							},
							{
								sumNet: ''
							},
							{
								sumNet: ''
							},
						],
					}
				}
			},
			editMode: Boolean,
			editQnsMode: Boolean,
			showErrors: Boolean,
			visible: Array,
			length: Number,
			type: Number,
			qSelected: Number,
		},
		computed: {
			shortenedChars() {
				return this.item.chars.substring(0, this.limitChars) + '...'
			},
			linkifiedChars() {
				return linkify(this.item.chars)
			},
			itemQty() {
				return this.item.qty
			},
		},
		created() {
			this.qtty = this.item.qty
		},
		watch: {
			itemQty(val) {
				this.qtty = val
			},
		},
		data: () => ({
			qtty: '',
			expandChars: false,
			limitChars: 50,
		}),
		methods: {
			qttyChange() {
				// console.log('qttyChange', this.item.qty, ' => ', this.qtty)

				if (this.item.qty != 0) {
					let c = this.qtty / this.item.qty
					this.item.qty = this.qtty
					this.item.qns.forEach(q => {
						q.sumNet = toStr(c * toNum(q.sumNet))
						// console.log('sumNet', ' => ', q.sumNet)
					})
				}
				else {
					this.item.qty = this.qtty
				}
			},
			toStr(val) {
				return toStr(val)
			},
			copy() {
				this.$emit('copy', this.item.num)
			},
			remove() {
				this.$emit('remove', this.item.num)
			},
			up() {
				this.$emit('up', this.item.num)
			},
			down() {
				this.$emit('down', this.item.num)
			},
		}
	}
</script>

<style scoped>

</style>
